import { render } from "./BasicInformationView.vue?vue&type=template&id=7c27a73e&scoped=true"
import script from "./BasicInformationView.vue?vue&type=script&lang=js"
export * from "./BasicInformationView.vue?vue&type=script&lang=js"

import "./BasicInformationView.vue?vue&type=style&index=0&id=7c27a73e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c27a73e"]])

export default __exports__